export default {
  default: {
    admin: '{global.organizationType.shortName.singular} Admin',
    user: '{global.organizationType.shortName.singular} User',
  },
}
